export const ASSET_URL = "https://assets.greygullapparel.com";

export const SIZE_KEY_MAP = {
  XS: "xs",
  S: "s",
  M: "m",
  L: "l",
  XL: "xl",
  XXL: "xxl",
};

export const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL"];

export const QUANTITIES = [1, 2, 3, 4, 5];
